namespace Areas.Transmittal.Detail {
    "use strict";


    export function goToActions(projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                Areas.Transmittal.Detail.goToSharePoint(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                Areas.Transmittal.Detail.goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                Areas.Transmittal.Detail.goToReportTransmittal(e);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    
    export function goToSharePoint(e: any) {
        const grid = $("#TransmittalGrid").dxDataGrid("instance");
        var sharePointLink = grid.option("SharePointLink") as string;
        if (isNotEmpty(sharePointLink)) {
            Areas.websiteSharePoint(sharePointLink);
        }
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

    export function goToReportTransmittal(e: any) {
        const grid = $("#TransmittalGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            var id = rows[0].transmittalId;
            const url = `/Reports/Report/GetReport860/${id}`;
            window.open(url);
        }
    }

}
